<absensi-input>
    <div class="container" style="margin-bottom: 2%;">
        <div class="filter-bar">
            <div class="filter-field">
                <div class="form-group {state.isSelectAcademicLoading}">
                    <select id="select-academic_year" class="form-select" onchange={onChangeAcademic}>
                        <option disabled selected>Tahun Akademik - Semester</option>
                        <option each={academicYear in state.academicYears} value={academicYear.ID}>
                            {academicYear.label}
                        </option>
                    </select>
                </div>
            </div>
            <div class="filter-field">
                <div class="form-group {state.isSelectClassLoading}">
                    <select id="select-class_label" class="form-select" onchange={onChangeClass}>
                        <option disabled selected>Pilih Kelas</option>
                        <option each={classItem in state.classItems} value={classItem.label}>{classItem.label}</option>
                    </select>
                </div>
            </div>
            <div class="filter-field">
                <input class="form-input" type="text" id="attendance_date" placeholder="Attendance date"
                       onchange={onChangeAttendanceDate}>
            </div>
            <div class="filter-field">
                <button class="btn btn-action" aria-label="Cari" onclick={search}><i class="icon icon-search"></i></button>
            </div>
        </div>
    </div>
    <div class={state.loadingData}>

    </div>
    <absensi-table students={state.students} attendanceDate={state.selectedAttendanceDate} academicYearID={state.selectedAcademicYear} classLabel={state.selectedClass} academicYears={state.academicYears} classItems={state.classItems}></absensi-table>
    <script>
        import AbsensiTable from '../absensi-table/absensi-table.riot';

        export default {
            components: {
                AbsensiTable,
            },
            state: {
                classItems: [],
                academicYears: [],
                students: undefined,
                selectedClass: '',
                selectedAcademicYear: '',
                componentUpdateSource: undefined,
                isSelectAcademicLoading: '',
                isSelectClassLoading: '',
                isStudentListLoading: '',
                loadingData: '',
                selectedAttendanceDate: '',
            },
            onMounted(props, state) {
                // right after the component is mounted on the page
                this.loadClasses();
                this.loadAcademicYears();
                const attendanceDate = document.getElementById('attendance_date');
                const datepicker = new Datepicker(attendanceDate, {
                    // ...options
                    format: 'yyyy-mm-dd',
                });
                datepicker.setDate('today')
                this.update({
                    selectedAttendanceDate:attendanceDate.value,
                    componentUpdateSource: 'FIELD_ATTENDANCE_DATE'
                })
                let p = this;
                attendanceDate.addEventListener('hide', function (e) {
                    if (e.target.value) {
                        p.update({
                            selectedAttendanceDate: e.target.value,
                            componentUpdateSource: 'FIELD_ATTENDANCE_DATE'
                        })
                    }
                })
            },
            onChangeAcademic(e) {
                this.update({
                    selectedAcademicYear: e.target.value,
                    componentUpdateSource: 'SELECT_BOX',
                })
            },
            onChangeClass(e) {
                this.update({
                    selectedClass: e.target.value,
                    componentUpdateSource: 'SELECT_BOX'
                })
            },
            loadClasses() {
                this.update({
                    isSelectClassLoading: 'loading',
                })
                axios.get(`/api/v1/classes`)
                    .then(res => {
                        this.update({
                            classItems: res.data.items,
                        })
                    }).catch(e => {
                    console.log(e);
                }).finally(() => {
                    this.update({
                        isSelectClassLoading: '',
                    })
                })
            },
            loadAcademicYears() {
                this.update({
                    isSelectAcademicLoading: 'loading',
                })
                axios.get(`/api/v1/academic-years`)
                    .then(res => {
                        this.update({
                            academicYears: res.data.items,
                        })
                    }).catch(e => {
                    console.log(e)
                }).finally(() => {
                    this.update({
                        isSelectAcademicLoading: '',
                    })
                })
            },
            search(e) {
                e.preventDefault();
                this.update({
                    loadingData: 'loading',
                    students: undefined,
                })
                let attendanceDate = document.getElementById('attendance_date').value;
                this.loadStudents(this.state.selectedAcademicYear, this.state.selectedClass, attendanceDate);
            },
            loadStudents(academicID, classLabel, attendanceDate) {
                if (academicID == "" || classLabel == "") {
                    return []
                }
                const fetch = async () => {

                    await axios.get(`/api/v1/student/attendance/list`, {
                        params: {
                            'academicYearID': academicID,
                            'classLabel': classLabel,
                            'attendanceDate': attendanceDate,
                        }
                    })
                        .then(res => {
                            this.update({
                                students: res.data.items ? res.data.items : [],
                            })
                        }).catch(e => {
                            console.log(e)
                        }).finally(() => {
                            this.update({
                                loadingData: '',
                            })
                        })
                }
                fetch()
            },
        }
    </script>
</absensi-input>
